const PAYPAY_POINTS_PCT = 2

export function calculatePaypayPoints(priceAmount: string): number {
  return Math.trunc((parseInt(priceAmount, 10) / 100) * PAYPAY_POINTS_PCT)
}
